module.exports = __webpack_public_path__ + "img/38925D_142B23_1D4835_2A6449-256px.98522638.png";